export default "__VITE_ASSET__BCyoIP_d__"